import React, { useState, useEffect, useRef, useContext, useReducer } from 'react'
import { LoginApi } from 'src/Api/api-Usuario'
import { useHistory } from "react-router-dom";
export const AuthContext = React.createContext()
import {
    CContainer,
    CSpinner
} from '@coreui/react'
export const AuthProvider = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const dataAuthInicial = {

    }
    //const history = useHistory();
    const [usuario, setUsuario] = React.useState(dataAuthInicial)



    const iniciarSesion = async (Correo, Password) => {
        try {
            setIsLoading(true);
            const rawResponse = await LoginApi(
                Correo, Password
            );

            const JsonResponse = await rawResponse.json();
            if (JsonResponse.status == 200) {
                sessionStorage.setItem('usuario', JSON.stringify(JsonResponse))
                sessionStorage.setItem("loggedin", true);
                setUsuario(JsonResponse)
                setIsLoading(false)
                return { error: false, usuario: JsonResponse, status: 200 }

            } else if (JsonResponse.status == 404) {
                //   console.log("error 404")
                setIsLoading(false)
                return { error: true, mensaje: 'Error 404', status: 404 }
            } else {
                // console.log("Otro error")
                setIsLoading(false)
                return { error: true, mensaje: 'Otro error', status: 400 }
            }


        } catch (error) {
            console.log(error)
            let mensaje = 'error';
            setIsLoading(false)
            return { error: true, mensaje: mensaje }
        }
    }

    const cerrarSesion = () => {
        // alert("llamando a cerrar sesion")
        sessionStorage.removeItem('usuario')
        sessionStorage.removeItem("loggedin");
        setUsuario({})
        // return auth.signOut()
    }


    React.useEffect(() => {
        const usuarioLocal = sessionStorage.getItem('usuario')

        if (usuarioLocal) {
            setUsuario(JSON.parse(usuarioLocal))

        }


    }, [])

    return (
        isLoading ? <div className="bg-light min-vh-100 d-flex flex-row align-items-center">


            <CContainer>
                <div className="row justify-content-center mb-3">
                    <CSpinner color="dark" />
                </div>
            </CContainer>
        </div> :
            <AuthContext.Provider value={{ usuario, cerrarSesion, iniciarSesion, setUsuario }}>
                {props.children}
            </AuthContext.Provider>
    )
}
